interface FeatureFlags {
  salesOsV2Enabled: boolean;
  salesOsV2EditEnabled: boolean;
}

function parseBooleanFlag(value: string | undefined, defaultValue: boolean): boolean {
  if (typeof value !== 'string') {
    return defaultValue;
  }

  const normalized = value.trim().toLowerCase();
  if (['1', 'true', 'yes', 'on'].includes(normalized)) {
    return true;
  }

  if (['0', 'false', 'no', 'off'].includes(normalized)) {
    return false;
  }

  return defaultValue;
}

export const featureFlags: FeatureFlags = {
  salesOsV2Enabled: parseBooleanFlag(import.meta.env.VITE_SALES_OS_V2_ENABLED, false),
  salesOsV2EditEnabled: parseBooleanFlag(import.meta.env.VITE_SALES_OS_V2_EDIT_ENABLED, false),
};
